import axios from 'axios'

const HOST_URL = process.env.VUE_APP_API_HOST
const API_VERSION = process.env.VUE_APP_API_VERSION

export default {
  getInsets (payload = {}) {
    return axios.get(`${HOST_URL}/v${API_VERSION}/deal-inset`, {
      params: payload
    })
  }
}
